import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { UiCommon } from '@/common/common';

/**
 * 스와이프 컴포넌트
 * @returns JSX.Element
 */

const YoutubeSwiper = () => {
	return (
		<section className="main-youtube main-section">
			<div className="main-tvcf-inner">
				<div className="title-group">
					<p className="sub">STELLA TV CF</p>
					<strong className="title">요즘 ERP, 스텔라로 스타트!</strong>
				</div>

				<Swiper
					className="tvcf-swiper"
					modules={[Navigation]}
					spaceBetween={30}
					slidesPerView={1.1}
					centeredSlides={true}
					navigation={{
						nextEl: '.swiper-control .swiper-button-next',
						prevEl: '.swiper-control .swiper-button-prev'
					}}>
					<SwiperSlide className="tvcf-slide slide1">
						<iframe
							width="988"
							height="554"
							src="https://www.youtube.com/embed/pYwv9vZNAOU?si=IHzJCHTATDLGnt7c"
							title="YouTube video player"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
					</SwiperSlide>
					<SwiperSlide className="tvcf-slide slide2">
						<iframe
							width="988"
							height="554"
							src="https://www.youtube.com/embed/a-DjI6HwDhY?si=NOMfKnyc2goFbzAX"
							title="YouTube video player"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
					</SwiperSlide>
				</Swiper>
				<div className="swiper-control">
					<div className="swiper-navigation">
						<div className="swiper-button-prev"></div>
						<div className="swiper-button-next"></div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default YoutubeSwiper;
